export default __webpack_public_path__ + "static/media/haval.bbecc63e.jfif";